var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleIconLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M296.425 152.806C296.425 140.515 295.428 131.546 293.27 122.245H152.92V177.72H235.302C233.642 191.506 224.673 212.268 204.741 226.219L204.462 228.076L248.837 262.454L251.912 262.761C280.147 236.684 296.425 198.316 296.425 152.806Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M152.92 298.97C193.28 298.97 227.163 285.681 251.912 262.761L204.741 226.22C192.118 235.023 175.176 241.168 152.92 241.168C113.39 241.168 79.839 215.092 67.8791 179.05L66.1261 179.199L19.9833 214.909L19.3799 216.586C43.9616 265.418 94.4543 298.97 152.92 298.97Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.879 179.05C64.7232 169.749 62.8969 159.782 62.8969 149.485C62.8969 139.187 64.7232 129.221 67.7129 119.92L67.6293 117.939L20.9083 81.6553L19.3797 82.3824C9.24842 102.646 3.43506 125.401 3.43506 149.485C3.43506 173.569 9.24842 196.323 19.3797 216.587L67.879 179.05Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M152.92 57.8004C180.989 57.8004 199.924 69.9252 210.72 80.0576L252.908 38.866C226.998 14.7824 193.28 0 152.92 0C94.4543 0 43.9616 33.5508 19.3799 82.3821L67.7131 119.92C79.839 83.8775 113.39 57.8004 152.92 57.8004Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIconLogo);
export default __webpack_public_path__ + "static/media/google-icon-logo.93223ecae713241bc2e494f8a8c75461.svg";
export { ForwardRef as ReactComponent };